import React from 'react';

import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';
import {ExamNearestDateProfessionalListProps} from './types';
import {ProfessionalDateList} from 'presentation/modules/booking/shared/ui/components/ProfessionalSelection/ProfessionalDateList';
import {ProfessionalDateSection} from 'presentation/modules/booking/shared/ui/components/ProfessionalSelection/ProfessionalDateSection';

export function ExamNearestDateProfessionalList({
	list,
	handleSelectHour,
	query,
}: ExamNearestDateProfessionalListProps) {
	return (
		<ProfessionalDateList>
			{list?.map(timesByDate => (
				<ProfessionalDateSection
					key={timesByDate.date}
					date={timesByDate.date}
					professionals={timesByDate.times}
					onSelectHour={handleSelectHour}
					flowType={FlowEnum.EXAM}
					query={query}
				/>
			))}
		</ProfessionalDateList>
	);
}
